<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
    <v-row  >
      <v-col md="12" lg="12" cols="12">
         <div>
      <v-breadcrumbs  style="color: #393E46 !important;" :items="dbreads" large></v-breadcrumbs>
    </div>


      <v-row justify="center" align="center">
        <v-col md="8" lg="8" cols="12">
          <v-card color="#393E46">
            <v-card-title>
          Ingresa Lista
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-autocomplete v-model="fiestaId" :items="fiestas" placeholder="Fiesta" item-value="id" :item-text="item => item.nombre +' - Fecha: '+ item.fechaInicio"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete v-model="tipoListaId" :items="tiposlista" item-value="id" placeholder="Tipos de Lista" item-text="tipoListaNombre"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete v-model="promotorId" :items="promotores" item-value="id" placeholder="Promotor" item-text="promotor"
                  >

                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea v-model="nombres" auto-grow rows="6" outlined placeholder="COPIA Y PEGA LOS NOMBRES"></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn color="#6D9886" @click="save">Generar</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
        <v-alert
            :value="alertnuevo"
            color="primary"
            dark
            dismissible
            border="top"
            transition="scale-transition"
        >
          Sus Nombres se agregaron con éxito.
        </v-alert>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import moment from "moment";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Genera Lista | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      overlay: false,
      idnegocio: 0,
      negocio: {},
      nombres:'',
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Codigos',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      abreviado:'NN',
      dialog: false,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      Promotors: [],
      promotores:[],
      tiposlista:[],
      fiestas:[],
      qrs:[],
      cantidad:0,
      promotorId:0,
      fiestaId:0,
      tipoListaId:0
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.damePromotors();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })

    }else{
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

      this.damePromotors();
    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
          this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

          this.damePromotors();
    },
  },
  methods : {
    dametiposlista(){
      this.overlay = true
      let urltipolista = 'tipolistas/negocio/' + this.idnegocio ;
      axios
          .get(urltipolista,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.tiposlista = response.data;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false;
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    },
    damePromotors(){
      this.overlay = true;
      axios
          .get('promotores/negocio/lista/'+this.idnegocio,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.promotores = response.data
            this.overlay = false;
            this.progr = false;
            this.alertnuevo = false;
            this.damefiestas();
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
          });
    },
    incrementNo () {
      this.cantidad = parseInt(this.cantidad,10) + 1
    },
    decrementNo () {
      this.cantidad = parseInt(this.cantidad,10) - 1
    },
    damefiestas(){
      this.overlay = true
      let urlfiesta = 'actos/fiestas/negociotag/' + this.idnegocio ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.fiestas = response.data;
            this.alertnuevo = false;
            this.overlay = false;
            this.dametiposlista();
          })
          .catch((error)  => {
            this.overlay = false;
            console.log(error);
          });
    },


    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    save () {
      this.overlay = true;

      var bodyFormData = new FormData();
      bodyFormData.append("promotorId",this.promotorId);
      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      bodyFormData.append("nombres",this.nombres);
      axios
          .post('lista/fiesta/nuevo',bodyFormData).then(response => {
        console.log(response.data)
        this.alertnuevo = true;
        this.overlay = false;
      })
          .catch(error => {
            this.overlay = false;
            this.error = "Hubo un error";
            console.log(error);
          });
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Temporada' : 'Editar Temporada'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
